import { render, staticRenderFns } from "./SingleAnswer.vue?vue&type=template&id=44701377&"
import script from "./SingleAnswer.vue?vue&type=script&lang=js&"
export * from "./SingleAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports